import { render, staticRenderFns } from "./UnderReviewList.vue?vue&type=template&id=4dedb256&scoped=true&"
import script from "./UnderReviewList.vue?vue&type=script&lang=js&"
export * from "./UnderReviewList.vue?vue&type=script&lang=js&"
import style0 from "./UnderReviewList.vue?vue&type=style&index=0&id=4dedb256&scoped=true&lang=css&"
import style1 from "./UnderReviewList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dedb256",
  null
  
)

export default component.exports